import { createContext } from "react";

export interface ArrMrrContextValue {
  isArr: boolean;
  fieldName: string;
  label: string;
  getValue: (object: any) => any;
  isLoading: boolean;
  // True only after a successful setting read: a failed read also stops loading.
  isResolved: boolean;
  error: any;
  refetch: () => void;
}

export const ArrMrrContext = createContext<ArrMrrContextValue | undefined>(
  undefined
);
